const state = {
  selected: null,
  list: [
    {
      id: 1,
      name: 'Sabrina1',
      from: '台北市大安區',
      phoneNumber: '0912-345-678',
      email: 'abc@gmail.com',
      alert: false,
      suspended: false,
      position: { lat: 25.0246511, lng: 121.5234588 }
    },
    {
      id: 2,
      name: 'Sabrina2',
      from: '台北市大安區',
      phoneNumber: '0912-345-678',
      email: 'abc@gmail.com',
      alert: false,
      suspended: false,
      position: { lat: 25.0220399, lng: 121.5484373 }
    },
    {
      id: 3,
      name: 'Sabrina3',
      from: '台北市大安區',
      phoneNumber: '0912-345-678',
      email: 'abc@gmail.com',
      alert: false,
      suspended: false,
      position: { lat: 25.0240399, lng: 121.5454373 }
    },
    {
      id: 4,
      name: 'Sabrina4',
      from: '台北市大安區',
      phoneNumber: '0912-345-678',
      email: 'abc@gmail.com',
      alert: false,
      suspended: false,
      position: { lat: 25.0223399, lng: 121.5484673 }
    },
    {
      id: 5,
      name: 'Sabrina5',
      from: '台北市大安區',
      phoneNumber: '0912-345-678',
      email: 'abc@gmail.com',
      alert: false,
      suspended: false,
      position: { lat: 25.0222399, lng: 121.5489373 }
    }
  ]
}

const getters = {
  list ({ list }) {
    return list
  },
  currentRider ({ selected, list }) {
    if (!selected) return null
    return list.find(rider => rider.id === selected)
  }
}

const actions = {
  select ({ commit }, id) {
    commit('SET_SELECTED', id)
  },
  clearSelected ({ commit }, id) {
    commit('SET_SELECTED', null)
  }
}

const mutations = {
  SET_SELECTED (state, value) {
    state.selected = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
